import { ref } from 'vue'

export const isDebugToolsEnabled = ref(false)
